import {
  DiscountBxgy,
  DiscountFixedAmount,
  DiscountPercentage,
} from '@/modules/store/models/Discount';
import { CalculatedPrice } from '@/modules/store/models/Price';
import { formatPrice } from '@/utils/currency';

interface CartItemPromotionAlertProps {
  item: {
    unitPrice?: CalculatedPrice;
    quantity?: number;
  };
}

const CartItemPromotionAlert = ({
  item: { unitPrice: price, quantity },
}: CartItemPromotionAlertProps) => {
  if (!price?.promotion) return null;

  const promotion = price.promotion;
  const discountPercentage = promotion.discounts.find(
    (d): d is DiscountPercentage => d.discountType === 'percentage',
  );
  const discountFixedAmount = promotion.discounts.find(
    (d): d is DiscountFixedAmount => d.discountType === 'fixedAmount',
  );
  const bxgyDiscount = promotion.discounts.find(
    (d): d is DiscountBxgy => d.discountType === 'bxgy',
  );

  let message: string;
  let reached = false;

  if (discountPercentage) {
    message = `${discountPercentage.percentage}% off`;
  } else if (discountFixedAmount) {
    message = `${formatPrice(discountFixedAmount.amount)} off`;
  } else if (bxgyDiscount) {
    const requiredQty = bxgyDiscount.buyQuantity + bxgyDiscount.getQuantity;
    reached = typeof quantity === 'number' && quantity >= requiredQty;
    message = `Buy ${bxgyDiscount.buyQuantity} Get ${bxgyDiscount.getQuantity}`;
  } else {
    message = 'Promotion available';
  }

  const isBxgyReached = bxgyDiscount && reached;

  return (
    <div
      role="alert"
      className={`mt-1 inline-block self-start rounded-md p-2 text-sm ${
        isBxgyReached
          ? 'bg-green-50 text-green-700 border border-green-100'
          : 'bg-yellow-50 text-yellow-800 border border-yellow-100'
      }`}
    >
      Promotion Applied: <span className="text-nowrap">{message}</span>
      {bxgyDiscount && !reached && (
        <span className="ml-1 text-xs">
          (add {bxgyDiscount.buyQuantity + bxgyDiscount.getQuantity - (quantity ?? 0)} more)
        </span>
      )}
    </div>
  );
};

export default CartItemPromotionAlert;
